import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  BUTTON_SIZE
} from '../../../themes'
import { colorThemeSelector } from '../../../helpers'
const padding = 70
export const StyleModal = styled.div`
  .sub-content {
    padding: 70px 60px 40px 60px;
  }

  .content-modal{
    border-radius: 8px;
    z-index: 7;
    color: ${COLOR.BLACK_1};
    display: block;
    position: fixed;
    background: #FFF;
    top: 35%;
    width: ${660 - padding}px;
    font-size: ${FONT_SIZE.SM};
    padding-left: ${padding}px;
    padding-right: ${padding}px;
    text-align: center;
    left: 0;
    right: 0;
    margin: auto;
    -webkit-animation-name: example; /* Safari 4.0 - 8.0 */
    -webkit-animation-duration: 0.5s; /* Safari 4.0 - 8.0 */
    animation-name: example;
    animation-duration: 0.5s;
  }


  /* Safari 4.0 - 8.0 */
  @-webkit-keyframes example {
    0%   {
      padding-left: 30px;
      padding-right: 30px;
    }
    100%  {
      padding-left: ${padding}px;
      padding-right: ${padding}px;
    }
  }

  /* Standard syntax */
  @keyframes example {
    0%   {
      padding-left: 30px;
      padding-right: 30px;
    }
    100%  {
      padding-left: ${padding}px;
      padding-right: ${padding}px;
    }
  }

  .description{
    margin-top: 30px;
    font-size: ${FONT_SIZE.XS};
    color: ${COLOR.BLACK_1};
    margin-bottom: 20px;
  }

  .table-row{
    display:flex;
  }

  .modal-btn-confirm, .modal-btn-cancel{
    margin-top: 40px;
    width: 196px;
    margin: 26px;
    font-size: ${FONT_SIZE.XXS};
    line-height:${BUTTON_SIZE.LINE_HEIGHTS.MD};
    border: 1px solid ${COLOR.GRAY_6};
    background: ${COLOR.WHITE};
    float: none;
    color: ${COLOR.BLACK_1};
  }

  .modal-btn-confirm{
    border: 1px solid ${COLOR.GOLD_1};
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    margin-left: 10px;
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT ?? COLOR.BLACK_1};
  }
`